import React from "react";
import CollectionNfts from "../../sections/Collection/CollectionNfts/CollectionNfts";
import HeroSection from "../../sections/Collection/HeroSection/HeroSection";
import Artists from "../../components/Artists/Artists";

const CollectionPage = () => {

  return (
    <div>
      <HeroSection />
      <CollectionNfts />
      <Artists custom />
    </div>
  );
};

export default CollectionPage;
